import { render, staticRenderFns } from "./admin-edit-lead-status-cat.vue?vue&type=template&id=132dcad8&scoped=true&"
import script from "./admin-edit-lead-status-cat.vue?vue&type=script&lang=js&"
export * from "./admin-edit-lead-status-cat.vue?vue&type=script&lang=js&"
import style0 from "./admin-edit-lead-status-cat.vue?vue&type=style&index=0&id=132dcad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132dcad8",
  null
  
)

export default component.exports